import React from 'react';

const sectionTitleStyle = {
  fontSize: 'clamp(2rem, 4vw, 3rem)',
  fontWeight: 800,
  color: '#2c0e16',
  marginBottom: '1rem',
  letterSpacing: '-0.03em'
};

const softCardStyle = {
  background: '#ffffff',
  border: '1px solid rgba(124, 40, 55, 0.10)',
  borderRadius: '28px',
  boxShadow: '0 18px 50px rgba(124, 40, 55, 0.08)'
};

const HomePage = () => {
  return (
    <div style={{ fontFamily: 'Poppins, sans-serif', background: '#f6efe8', color: '#2c0e16' }}>
      <section
        style={{
          background: 'linear-gradient(135deg, #7c2837 0%, #943143 52%, #b34557 100%)',
          color: '#fff',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.18) 0, transparent 30%), radial-gradient(circle at 85% 30%, rgba(255,255,255,0.12) 0, transparent 25%), linear-gradient(180deg, rgba(0,0,0,0.08), rgba(0,0,0,0.18))' }} />
        <div className="container" style={{ position: 'relative', zIndex: 1, padding: '96px 16px' }}>
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <div style={{ marginBottom: '2rem' }}>
                <img
                  src="/images/logo/BOUILLON de copains - WHITE.png"
                  alt="Bouillon de Copains"
                  style={{ width: 'min(100%, 520px)', height: 'auto', display: 'block', margin: '0 auto', filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.22))' }}
                />
              </div>
              <h1 style={{ fontSize: 'clamp(2.6rem, 6vw, 5.2rem)', fontWeight: 800, lineHeight: 1.02, marginBottom: '1.5rem', letterSpacing: '-0.05em' }}>
                Une association pour créer, organiser et faire durer de vrais liens.
              </h1>
              <p style={{ fontSize: 'clamp(1.05rem, 2vw, 1.3rem)', lineHeight: 1.8, maxWidth: 820, color: 'rgba(255,255,255,0.92)', margin: '0 auto 2.2rem' }}>
                Bouillon de Copains conçoit un cadre associatif qui permet a ses membres de proposer des rencontres, de porter des evenements et de participer a une vie collective fondee sur la confiance, la convivialite et l'engagement.
              </p>
              <div className="d-flex gap-3 flex-wrap justify-content-center">
                <a href="/events" style={{ background: '#fff7f1', color: '#7c2837', textDecoration: 'none', fontWeight: 700, padding: '16px 30px', borderRadius: 999, boxShadow: '0 14px 30px rgba(0,0,0,0.18)' }}>
                  Voir les événements
                </a>
                <a href="/connexion" style={{ background: 'transparent', color: '#fff', textDecoration: 'none', fontWeight: 700, padding: '16px 30px', borderRadius: 999, border: '1.5px solid rgba(255,255,255,0.45)' }}>
                  Se connecter
                </a>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section id="mot-president" style={{ padding: '96px 0', background: 'linear-gradient(180deg, #f6efe8 0%, #fff8f4 100%)' }}>
        <div className="container-fluid" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
          <div style={{ width: 'min(1500px, calc(100vw - 40px))', margin: '0 auto' }}>
            <div style={{ ...softCardStyle, overflow: 'hidden', background: '#fffdfb' }}>
              <div className="row g-0 align-items-stretch">
                <div className="col-lg-5 col-xl-5">
                  <div style={{ height: '100%', minHeight: '100%', background: '#ead9d2', position: 'relative' }}>
                    <img
                      src="/images/cefsdp_motduprez.png"
                      alt="Charles-Emmanuel Foussé Savoye de Puineuf"
                      style={{ width: '100%', height: '100%', minHeight: '100%', display: 'block', objectFit: 'cover', objectPosition: 'center top' }}
                    />
                    <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, padding: '34px 28px 24px', background: 'linear-gradient(180deg, rgba(22,9,13,0) 0%, rgba(22,9,13,0.82) 72%, rgba(22,9,13,0.96) 100%)' }}>
                      <div style={{ color: '#fff', fontWeight: 700, fontSize: '1.08rem', lineHeight: 1.45 }}>
                        Charles-Emmanuel Foussé Savoye de Puineuf
                      </div>
                      <div style={{ color: 'rgba(255,244,239,0.82)', fontSize: '0.92rem', lineHeight: 1.6, marginTop: '0.35rem' }}>
                        Président fondateur • Bouillon de Copains
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-7 col-xl-7">
                  <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: 'linear-gradient(180deg, #8f3345 0%, #7c2837 100%)', padding: 'clamp(24px, 4vw, 42px)' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', alignSelf: 'flex-start', padding: '8px 14px', borderRadius: 999, background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(255,255,255,0.14)', color: '#fff4ef', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: '1.2rem' }}>
                      Mot du président
                    </div>

                    <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.3rem)', fontWeight: 800, color: '#fff', lineHeight: 1.05, letterSpacing: '-0.05em', marginBottom: '1.4rem', maxWidth: 680 }}>
                      Retrouvons le goût de nous rassembler.
                    </h2>

                    <div style={{ display: 'grid', gap: 18, marginBottom: '1.8rem' }}>
                      <p style={{ color: 'rgba(255,244,239,0.94)', fontSize: '1.08rem', lineHeight: 1.9, margin: 0 }}>
                        Depuis la pandémie, nous avons peu à peu perdu l'habitude de prendre le temps <strong>d'organiser</strong>, <strong>d'inviter</strong> et de <strong>nous retrouver</strong>. Les moments de convivialité se sont raréfiés, et avec eux ces liens authentiques qui donnent de la profondeur à nos vies.
                      </p>

                      <p style={{ color: 'rgba(255,244,239,0.9)', fontSize: '1.02rem', lineHeight: 1.9, margin: 0 }}>
                        C'est précisément la raison d'être de <strong>Bouillon de Copains</strong> : offrir à ses adhérents un <strong>cadre associatif vivant</strong>, un <strong>réseau de confiance</strong> et des moyens concrets pour imaginer, proposer et organiser des événements mémorables <strong>en toute autonomie</strong>.
                      </p>

                      <p style={{ color: 'rgba(255,244,239,0.9)', fontSize: '1.02rem', lineHeight: 1.9, margin: 0 }}>
                        Ici, vous ne subissez pas un calendrier imposé. Vous créez vos rencontres, vous partagez vos idées et vous bénéficiez du soutien de la communauté pour leur donner corps. Ensemble, redonnons vie à <strong>l'art de se retrouver</strong>.
                      </p>
                    </div>

                    <div style={{ marginTop: 'auto', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '22px', padding: '20px 22px' }}>
                      <p style={{ color: '#fff', fontSize: '1.05rem', lineHeight: 1.8, fontWeight: 600, margin: '0 0 0.9rem' }}>
                        « Au plaisir de vous accueillir prochainement autour d'un bon bouillon. »
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '96px 0', background: '#f6efe8' }}>
        <div className="container">
          <div className="row align-items-start g-4">
            <div className="col-lg-5">
              <div style={{ display: 'inline-block', padding: '8px 16px', borderRadius: 999, background: '#f1d8d1', color: '#7c2837', fontWeight: 700, fontSize: '0.85rem', marginBottom: '1rem' }}>Pourquoi nous existons</div>
              <h2 style={sectionTitleStyle}>Une association pour remettre les relations au centre.</h2>
              <p style={{ fontSize: '1.08rem', lineHeight: 1.85, color: '#5a3340' }}>
                Le Bouillon de Copains est ne d'une idee simple : faire exister une vie associative ou les membres peuvent se rencontrer regulierement, proposer des initiatives et construire des relations plus fortes autour d'evenements choisis.
              </p>
            </div>
            <div className="col-lg-7">
              <div className="row g-4">
                {[
                  ['Rencontres choisies', 'La cooptation et la confiance entre membres servent la qualite des echanges et la coherence de la communaute.', '🤝'],
                  ['Organisation fluide', 'L’association fournit un cadre, des outils et des regles simples pour faciliter la mise en place d’evenements.', '🗓️'],
                  ['Vie collective', 'Chaque membre peut proposer, participer, aider a organiser et contribuer a la dynamique de l’association.', '✨']
                ].map(([title, text, icon]) => (
                  <div className="col-md-4" key={title}>
                    <div style={{ ...softCardStyle, padding: '28px', height: '100%' }}>
                      <div style={{ width: 44, height: 44, borderRadius: 14, background: 'linear-gradient(135deg, #7c2837, #b34557)', marginBottom: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '1.1rem', boxShadow: '0 10px 24px rgba(124, 40, 55, 0.18)' }}>
                        {icon}
                      </div>
                      <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#2c0e16', marginBottom: '0.8rem' }}>{title}</h3>
                      <p style={{ color: '#6c4a55', lineHeight: 1.75, margin: 0 }}>{text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="mission" style={{ padding: '96px 0', background: '#fffaf6' }}>
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <div style={{ ...softCardStyle, padding: '34px', background: 'linear-gradient(180deg, #ffffff, #fcf3ee)' }}>
                <div style={{ display: 'grid', gap: 16 }}>
                  {[
                    ['Événements amicaux', 'Repas, sorties, soirées, rencontres culturelles ou formats imaginés par les membres.'],
                    ['Cadre clair', 'Des règles lisibles, un rôle organisateur bien défini et une gouvernance associatrice.'],
                    ['Engagement progressif', 'Chacun participe à son rythme, de la découverte à l’organisation active.']
                  ].map(([title, text]) => (
                    <div key={title} style={{ background: '#fff', borderRadius: 20, padding: '18px 20px', border: '1px solid rgba(124, 40, 55, 0.10)' }}>
                      <div style={{ fontWeight: 700, color: '#7c2837', marginBottom: 6 }}>{title}</div>
                      <div style={{ color: '#6c4a55', lineHeight: 1.7 }}>{text}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div style={{ display: 'inline-block', padding: '8px 16px', borderRadius: 999, background: '#f1d8d1', color: '#7c2837', fontWeight: 700, fontSize: '0.85rem', marginBottom: '1rem' }}>Vie associative</div>
              <h2 style={sectionTitleStyle}>Comment fonctionne Bouillon de Copains.</h2>
              <p style={{ fontSize: '1.05rem', lineHeight: 1.85, color: '#5a3340', marginBottom: '1.2rem' }}>
                L’association donne a ses membres la possibilite d’organiser des repas, des sorties, des rencontres culturelles ou festives, tout en conservant un cadre lisible sur les roles, les inscriptions et la responsabilite de chacun.
              </p>
              <p style={{ fontSize: '1.05rem', lineHeight: 1.85, color: '#5a3340' }}>
                Son role n’est pas seulement d’annoncer des evenements, mais de rendre possible une vraie vie collective : permettre aux membres de proposer, de coordonner, de participer et de faire vivre un esprit de convivialite durable.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '96px 0', background: '#f3e6df' }}>
        <div className="container">
          <div style={{ ...softCardStyle, background: 'linear-gradient(135deg, #7c2837, #9b384d)', color: '#fff', padding: '48px 42px', border: 'none' }}>
            <div className="row align-items-center g-4">
              <div className="col-lg-8">
                <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.2rem)', fontWeight: 800, marginBottom: '1rem' }}>Une communauté qui se construit par la qualité des liens.</h2>
                <p style={{ color: 'rgba(255,255,255,0.92)', lineHeight: 1.8, fontSize: '1.08rem', margin: 0 }}>
                  Decouvre le projet associatif, comprends comment il fonctionne et retrouve les informations utiles pour rejoindre la dynamique du Bouillon de Copains.
                </p>
              </div>
              <div className="col-lg-4 d-flex gap-3 flex-wrap justify-content-lg-end">
                <a href="/events" style={{ background: '#fff7f1', color: '#7c2837', textDecoration: 'none', fontWeight: 700, padding: '14px 24px', borderRadius: 999 }}>Événements</a>
                <a href="/contacts" style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.35)', color: '#fff', textDecoration: 'none', fontWeight: 700, padding: '14px 24px', borderRadius: 999 }}>Contacts</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── COMMENT REJOINDRE L'ASSOCIATION ──────────────────────── */}
      <section style={{ padding: '96px 0', background: '#fffaf6' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '3.5rem' }}>
            <div style={{ display: 'inline-block', padding: '8px 16px', borderRadius: 999, background: '#f1d8d1', color: '#7c2837', fontWeight: 700, fontSize: '0.85rem', marginBottom: '1rem' }}>Adhésion</div>
            <h2 style={sectionTitleStyle}>Comment rejoindre l'association</h2>
            <p style={{ fontSize: '1.08rem', lineHeight: 1.85, color: '#5a3340', maxWidth: 680, margin: '0 auto' }}>
              Bouillon de Copains fonctionne par cooptation : chaque nouveau membre est parrainé par un adhérent existant. Voici les étapes pour nous rejoindre.
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {[
              {
                step: '1',
                icon: '🤝',
                title: 'Être parrainé',
                desc: 'Un membre actif de l\'association vous propose de rejoindre Bouillon de Copains. Il remplit une demande de parrainage en votre nom.'
              },
              {
                step: '2',
                icon: '📩',
                title: 'Recevoir l\'invitation',
                desc: 'Vous recevez un lien d\'invitation par email. Créez votre compte en renseignant vos informations personnelles.'
              },
              {
                step: '3',
                icon: '✅',
                title: 'Validation par le bureau',
                desc: 'Votre candidature est examinée par le bureau de l\'association. Une fois approuvée, vous devenez officiellement membre.'
              },
              {
                step: '4',
                icon: '🎉',
                title: 'Participer & organiser',
                desc: 'Accédez aux événements, inscrivez-vous aux sorties et commencez à proposer vos propres rencontres à la communauté.'
              }
            ].map(({ step, icon, title, desc }) => (
              <div className="col-lg-3 col-md-6" key={step}>
                <div style={{ ...softCardStyle, padding: '32px 26px', height: '100%', textAlign: 'center', position: 'relative' }}>
                  <div style={{
                    position: 'absolute', top: -18, left: '50%', transform: 'translateX(-50%)',
                    width: 36, height: 36, borderRadius: '50%',
                    background: 'linear-gradient(135deg, #7c2837, #a8384e)',
                    color: '#fff', fontWeight: 800, fontSize: '0.95rem',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 6px 20px rgba(124, 40, 55, 0.25)'
                  }}>
                    {step}
                  </div>
                  <div style={{ fontSize: '2rem', marginBottom: '0.8rem', marginTop: '0.5rem' }}>{icon}</div>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#2c0e16', marginBottom: '0.7rem' }}>{title}</h3>
                  <p style={{ color: '#6c4a55', lineHeight: 1.75, margin: 0, fontSize: '0.95rem' }}>{desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center" style={{ marginTop: '3rem' }}>
            <div style={{ ...softCardStyle, display: 'inline-block', padding: '20px 32px', background: '#fdf6f0' }}>
              <p style={{ color: '#5a3340', fontSize: '1rem', lineHeight: 1.7, margin: '0 0 0.8rem' }}>
                Vous connaissez un membre ? Demandez-lui de vous parrainer !
              </p>
              <a href="/contacts" style={{
                display: 'inline-block', background: 'linear-gradient(135deg, #7c2837, #a8384e)',
                color: '#fff', textDecoration: 'none', fontWeight: 700,
                padding: '12px 28px', borderRadius: 999,
                boxShadow: '0 10px 28px rgba(124, 40, 55, 0.2)'
              }}>
                Nous contacter
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer style={{ background: '#2a1018', color: '#f8eeea', padding: '52px 0 36px' }}>
        <div className="container">
          <div className="row g-4 align-items-start">
            <div className="col-lg-5">
              <div style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '0.8rem' }}>Bouillon de Copains</div>
              <p style={{ color: 'rgba(248,238,234,0.72)', lineHeight: 1.8, maxWidth: 420, marginBottom: 0 }}>
                Association declaree dediee a l’organisation d’evenements amicaux, culturels et festifs pour renforcer les liens entre ses membres.
              </p>
            </div>
            <div className="col-lg-3">
              <div style={{ fontWeight: 700, marginBottom: '0.8rem' }}>Navigation</div>
              <div style={{ display: 'grid', gap: 8 }}>
                <a href="/" style={{ color: 'rgba(248,238,234,0.72)', textDecoration: 'none' }}>Accueil</a>
                <a href="/events" style={{ color: 'rgba(248,238,234,0.72)', textDecoration: 'none' }}>Événements</a>
                <a href="/contacts" style={{ color: 'rgba(248,238,234,0.72)', textDecoration: 'none' }}>Contacts</a>
              </div>
            </div>
            <div className="col-lg-4">
              <div style={{ fontWeight: 700, marginBottom: '0.8rem' }}>Contact</div>
              <div style={{ color: 'rgba(248,238,234,0.72)', lineHeight: 1.8 }}>
                <div>48 rue de Varenne, 75007 Paris</div>
                <div><a href="mailto:contact@bouillondecopains.com" style={{ color: '#fff7f1', textDecoration: 'none' }}>contact@bouillondecopains.com</a></div>
              </div>
            </div>
          </div>
          <div style={{ borderTop: '1px solid rgba(255,255,255,0.10)', marginTop: 28, paddingTop: 22, color: 'rgba(248,238,234,0.55)', fontSize: '0.92rem' }}>
            © {new Date().getFullYear()} Bouillon de Copains · Association loi 1901
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;